import React from 'react';
import { useTranslations } from 'next-intl';
import { PlayCircleIcon } from '@heroicons/react/20/solid';
import Image from 'next/image';
import styles from './tutorials.module.css';

type HowItWorksItemProps = {
  title: string;
  description: string;
  onClick: () => void;
  imgCoverPath: string;
  href: string;
};

function HowItWorksItem({
  title,
  description,
  onClick,
  imgCoverPath,
}: HowItWorksItemProps) {
  const howItWorksText = useTranslations('tutorials.how_it_works');

  return (
    <div className="flex flex-col gap-10 md:flex-row">
      <div className="flex-1">
        <div className="relative flex max-w-[400px] items-center justify-center">
          <Image
            src={imgCoverPath}
            height={400}
            width={400}
            alt="Video Cover image"
            className="rounded-2xl brightness-50"
            style={{ objectFit: 'contain' }}
          />
          <div className={`${styles.title}  font-semibold text-white `}>
            {title}
          </div>
          <Image
            src="/about_us/white_logo.png"
            width={20}
            height={10}
            alt="White logo"
            className={`${styles.logo}`}
          />

          <div
            onClick={onClick}
            className={`${styles.play} transform cursor-pointer transition-transform hover:scale-150 hover:text-[#9A1B21]`}
          >
            <PlayCircleIcon className="h-10 w-10 text-[#CE1126] transition-colors duration-300" />
          </div>
        </div>
      </div>

      <div className="flex-1">
        <div className="flex flex-col items-start justify-start gap-y-5 sm:gap-y-3 md:gap-y-5 lg:gap-y-10">
          <div className="text-xl font-bold text-primary-dark">{title}</div>
          <div className="max-w-xs text-justify text-xs text-primary-pale lg:max-w-sm lg:text-sm">
            {description}
          </div>

          <div
            onClick={onClick}
            className="transform cursor-pointer rounded-md bg-primary p-2 text-center text-sm text-white transition-transform hover:scale-110 hover:font-bold"
          >
            {howItWorksText('watch_video')}
          </div>
        </div>
      </div>
    </div>
  );
}

export default HowItWorksItem;
